import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { menuTitleArr } from "../../config";
import logo from "../../images/logo.png";
import * as bootstrap from "bootstrap";
import "./sidebar.css";

export default function Sidebar({ collapsed, setCollapsed }) {

    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();
    const isMobile = window.innerWidth <= 991;

    useEffect(() => {
        if (isMobile) {
            setMobileOpen(false);
        }
    }, [location.pathname]);

    let currentPathName =
        location?.pathname?.length > 1
            ? location?.pathname?.split("/")[1]
            : location?.pathname?.split("/")[0];

    return (
        <>
            {/* MOBILE HAMBURGER */}
            <button
                className="btn toggle-btn mobile-toggle bg-white  position-fixed m-md-3 m-1 mt-1  border border-1"
                style={{ zIndex: 999 }}
                onClick={() => setMobileOpen(true)}
            >
                <i className="bi bi-list text-black fs-1"></i>
            </button>

            {/* OVERLAY */}
            {mobileOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={() => setMobileOpen(false)}
                ></div>
            )}

            <div
                className={`text-white sidebar 
                ${collapsed ? "collapsed" : ""} 
                ${mobileOpen ? "mobile-open" : ""}`}
            >
                <div className="sidebar-header">
                    {!collapsed && (
                        <img src={logo} alt="logo" className="sidebar-logo" />
                    )}

                    <button
                        className="btn btn-sm toggle-btn"
                        onClick={() => {
                            if (isMobile) {
                                setMobileOpen(false);
                            } else {
                                setCollapsed(!collapsed);
                            }
                        }}
                    >
                        <i className="bi bi-list"></i>
                    </button>
                </div>

                <ul className="nav nav-pills flex-column mb-auto sidebar-menu">
                    {menuTitleArr.map((menu, index) => {
                        if (!menu?.display) return null;

                        return (
                            <li className="nav-item" key={index}>
                                <Link
                                    to={`/${menu?.path}`}
                                    className={`nav-link d-flex align-items-center ${currentPathName === menu?.path
                                        ? "active text-white"
                                        : "text-white"
                                        }`}
                                    onClick={() => {
                                        if (isMobile) setMobileOpen(false);
                                    }}
                                >
                                    <i className={`bi ${menu?.icon} menu-icon`}></i>

                                    {!collapsed && (
                                        <span className="menu-text ms-2">
                                            {menu?.name}
                                        </span>
                                    )}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </>
    );
}
